import { useEffect, useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import UploadFinalXmContents from './upload-final-xm-contents';
import usePrevious from '@nkr/services/use-previous';
import UploadSerologyContents from './upload-serology-contents';

interface IProps {
    show: boolean,
    swap: string,
    onSend: (serologytFile: File) => void,
    onCancel: () => void
}

const UploadSerology = (props: IProps) => {
    const [upload, setUpload] = useState<File>(null);
    const previousShow = usePrevious(props.show);

    useEffect(() => {
        if (previousShow == false && props.show) {
            setUpload(null);
        }
    }, [props.show]);

    const handleSend = () => {
        if (upload != null) {
            props.onSend(upload);
        }
    };

    const handleCancel = () => {
        props.onCancel();
    };

    const handleSelectFile = (file: File) => {
        setUpload(file);
    };

    return (
        <Modal backdrop='static' show={props.show} onHide={handleCancel}>
            <Modal.Header closeButton>
                <Modal.Title>Record Serology Results for Swap {props.swap}</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <UploadSerologyContents
                    upload={upload}
                    isList={false}
                    onUploadChange={handleSelectFile} />
            </Modal.Body>

            <Modal.Footer>
                <Button bsStyle='primary' disabled={upload == null} onClick={handleSend}>Upload Serology Results</Button>
                <Button onClick={handleCancel}>Cancel</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default UploadSerology;